import React from 'react';
import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import { MEDIA_URL } from '../../axios';
import officeimg from '../../Assets/Home/saptagon website images/aboutus.jpg';
import officeimg2 from '../../Assets/Home/saptagon website images/aboutus002.jpg';
import officeimg3 from '../../Assets/Home/saptagon website images/aboutus003.jpg';
import officeimg4 from '../../Assets/Home/saptagon website images/aboutus004.jpg';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { div } from 'framer-motion/client';

const Aboutus = () => {
  const morearrow = MEDIA_URL + 'Home/more-arrow.svg';
  const officeimgs = [
    { img: officeimg },
    { img: officeimg2 },
    { img: officeimg3 },
    { img: officeimg4 },
  ];
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 2000,
    cssEase: 'linear',
  };

  return (
    <div className='-mt-12'>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
        className="max-md:-mt-20  max-lg:h-auto flex max-sm:flex-col justify-between max-sm:justify-center md:max-xl:h-[35vh] relative h-[70vh] about-us"
      >
        {/* Slider Component */}
        <motion.div
          initial={{ x: -50, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1 }}
          className="homeaboutus max-sm:hidden slider-container slide-in"
          style={{ height: '50%', width: '45%', margin: '10px 0 0 55px' }}
        >
          <Slider {...{ ...settings, dots: false }}>
            {officeimgs.map((item, i) => (
              <img
                src={item.img}
                alt="Saptagon Office"
                className="h-[55vh] mb-10 w-full object-cover rounded-xl"
                key={i}
              />
            ))}
          </Slider>
        </motion.div>

        {/* Mobile Slider */}
        <motion.div
          initial={{ x: 50, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1 }}
          className="homeaboutus sm:hidden slider-container slide-in"
          style={{ width: '100%', margin: '50px 0 0 0' }}
        >
          <Slider {...settings}>
            {officeimgs.map((item, i) => (
              <img
                src={item.img}
                alt="Saptagon Office"
                className="h-[30vh] object-cover rounded-lg"
                key={i}
              />
            ))}
          </Slider>
        </motion.div>

        {/* Content Section */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="max-lg:px-6 max-lg:w-full sm:max-xl:w-[52%] w-[50%] max-lg:gap-4 sm:max-xl:gap-4 flex flex-col gap-6 justify-start items-start pt-6 z-10 fade-in"
        >
          <span className="text-[30px] text-[#8364c3]">About Us</span>
          <p className="darkblue text-2xl md:text-5xl font-semibold fade-in">
            Pioneering Infrastructure <span className="purple">Solutions</span>
          </p>
          <p
            className="max-sm:w-full sm:max-xl:text-justify sm:max-xl:w-[90%] w-[92%] darkgray text-sm md:text-md fade-in my-2"
            style={{ textAlign: 'justify' }}
          >
            Saptagon Asia Pvt. Ltd. is a leading infrastructure consultancy with 13+ years of expertise, evolved from G-Eng Advisory Services Pvt. Ltd.
            Integrated Engineering Services: DPR, Feasibility Studies, Authority & Independent Engineering, PMC, O&M Supervision, and Safety Advisory.
            NABL-Accredited Laboratory supported by advanced testing equipment.
            In-House Advanced Survey & Testing Systems: 3D Laser Survey Vehicles, LDD, PRIMAX 3500 HWD, and Vehicle-Mounted FWD.
            Smart Infrastructure Monitoring: MBIU, BHMS, Wireless Structural Health Monitoring, and TDDS for predictive asset management.
          </p>
          <NavLink to="/About-us">
            <motion.div
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="inline-flex gap-2  btn btn-hover text-sm md:text-md transition-all rounded-full px-6 py-[14px] text-white my-0"
            >
              More Details
              <img src={morearrow} className='' alt="More Details" />
            </motion.div>
          </NavLink>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default Aboutus;
